<template>
	<div class="new-formula">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'mx-12' : 'pa-0'">
			<FormulaForm :providers="providers" :productUnits="productUnits" :productProcessing="productProcessing" :admin="admin" />
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import FormulaForm from "@/components/products/FormulaForm.vue";
import axios from "axios";

export default {
	name: "NewFormula",
	components: {
		Breadcrumbs,
		FormulaForm,
		NavBar
	},
	data: () => ({
		providers: [],
		productUnits: [],
		productProcessing: []
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		externalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		items() {
			return [
				... this.admin || !this.isExternalEntity ? [{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: this.admin ? { name: "dashboard" } : { name: "home" }
					}] : [],
				... !this.admin && !this.externalEntity ? [{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "treatments" }
					}] : [],
				{
					text: this.$gettext("Chinese Materia Medica"),
					disabled: false,
					link: true,
					to: this.admin ? { name: "admin-cmm", params: { admin: true } } : { name: "cmm" }
				},
				{
					text: this.$gettext("New Formula"),
					disabled: true,
					link: true
				}
			]
		}
	},
	created() {
		axios
			.get("/mtc/formulas/new")
			.then(response => {
				console.log(response.data);
				this.providers = response.data.providers;
				this.providers.push({ id: -1, name: this.$gettext("Create Provider...") });
				this.productUnits = response.data.product_units;
				this.productProcessing = response.data.product_processing;
			})
			.catch(error => {
				console.log(error);
			});
	}
};
</script>